import { setTrackLink, setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { removeCurrency } from '@vfit/consumer/hooks';
import { SoftManagerService } from '@vfit/consumer/providers';
import { useCoverageToolModalProvider } from '../../coverageToolModal.context';
import { useEffect } from 'react';

const CoverageToolMapCardTagging = () => {
  const queryClient = useQueryClient();
  const { address, product, isLoading } = useCoverageToolModalProvider();
  const pageProduct = {
    product_name: product?.slug,
    product_price: product?.price && removeCurrency(product.price),
    product_id: `${product?.offerId}`,
    product_quantity: '1',
    product_category: ['fixed'],
  };

  const opts = {
    event_category: 'tools',
    page_subsection: 'coverage tool',
    page_section: 'fixed offers',
    page_type: 'map',
    journey_name: 'coverage tool',
  };

  const { trackView } = useTracking({
    event: ['tool_end'],
    opts,
    pageProduct,
    visitorTrackingOpts: SoftManagerService(queryClient).getUser(),
  });

  setTrackView(trackView);
  setTrackLink(trackView);

  useEffect(() => {
    if (!isLoading) {
      localStorage.setItem('region_cus', address.region || '');
      localStorage.setItem(
        'address_cus',
        address.street?.concat(
          ' ',
          address.streetNumber || '',
          ', ',
          address.postalCode || '',
          ' ',
          address.city || ''
        ) || ''
      );
    }
  }, [isLoading]);

  return null;
};

export default CoverageToolMapCardTagging;
